// extracted by mini-css-extract-plugin
export default {"imageWrapper":"tF-z","twoColumnImage":"uF-z"};